import PayourlLogo from '../assets/PayourlLogo.svg'

function Logo() {
  return ( 
     <img className='logo' src={PayourlLogo} alt='logo'/>
  )
}

export default Logo